import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FindCodeSectionsQueryVariables = Types.Exact<{
  codeBookId: Types.Scalars['uuid']['input'];
  numberSearch: Types.Scalars['String']['input'];
  textSearch: Types.Scalars['String']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type FindCodeSectionsQuery = { __typename?: 'query_root', code_sections: Array<{ __typename?: 'code_sections', id: any, section_number: string, title?: string | null, page_number?: number | null, depth: number }> };


export const FindCodeSectionsDocument = gql`
    query findCodeSections($codeBookId: uuid!, $numberSearch: String!, $textSearch: String!, $limit: Int = 25) {
  code_sections(
    where: {code_book_id: {_eq: $codeBookId}, _or: [{section_number: {_ilike: $numberSearch}}, {title: {_ilike: $textSearch}}, {body: {_ilike: $textSearch}}]}
    order_by: {sort_key: asc}
    limit: $limit
  ) {
    id
    section_number
    title
    page_number
    depth
  }
}
    `;

/**
 * __useFindCodeSectionsQuery__
 *
 * To run a query within a React component, call `useFindCodeSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCodeSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCodeSectionsQuery({
 *   variables: {
 *      codeBookId: // value for 'codeBookId'
 *      numberSearch: // value for 'numberSearch'
 *      textSearch: // value for 'textSearch'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindCodeSectionsQuery(baseOptions: Apollo.QueryHookOptions<FindCodeSectionsQuery, FindCodeSectionsQueryVariables> & ({ variables: FindCodeSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCodeSectionsQuery, FindCodeSectionsQueryVariables>(FindCodeSectionsDocument, options);
      }
export function useFindCodeSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCodeSectionsQuery, FindCodeSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCodeSectionsQuery, FindCodeSectionsQueryVariables>(FindCodeSectionsDocument, options);
        }
export function useFindCodeSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindCodeSectionsQuery, FindCodeSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindCodeSectionsQuery, FindCodeSectionsQueryVariables>(FindCodeSectionsDocument, options);
        }
export type FindCodeSectionsQueryHookResult = ReturnType<typeof useFindCodeSectionsQuery>;
export type FindCodeSectionsLazyQueryHookResult = ReturnType<typeof useFindCodeSectionsLazyQuery>;
export type FindCodeSectionsSuspenseQueryHookResult = ReturnType<typeof useFindCodeSectionsSuspenseQuery>;
export type FindCodeSectionsQueryResult = Apollo.QueryResult<FindCodeSectionsQuery, FindCodeSectionsQueryVariables>;